// Eine heruntergeladene Datei im Browser speichern (Blob → Link → Klick).

export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.rel = "noopener";
  document.body.append(link);
  link.click();
  link.remove();
  // Erst nach dem Klick freigeben, sonst bricht der Download in manchen Browsern ab
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
